import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";
import { Dimmer } from "../components/spinner.jsx";
import { DangerButton, SuccessButton } from "../ui/buttons/Button.jsx";

const CatalogoOrganizacionPrincipal = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
    { label: "DIRECCIÓN", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idorganizacion.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.domicilio.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarOrganizacion = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "organizacion";
    let orden = "idorganizacion";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var clase = [];
          for (let i = 0; i < response.data.length; i++) {
            clase.push({
              idorganizacion: response.data[i].idorganizacion,
              nombre: response.data[i].nombre,
              domicilio: response.data[i].domicilio,
            });
          }
          setRecords(clase);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const selectOrganizacion = () => {
    blanquear();
    props.onHideAceptaCatOrg(
      values.idorganizacion,
      values.nombre,
      values.domicilio
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    setValues({
      idorganizacion: recordsAfterPagingAndSorting()[index].idorganizacion,
      nombre: recordsAfterPagingAndSorting()[index].nombre,
      domicilio: recordsAfterPagingAndSorting()[index].domicilio,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="lg"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarOrganizacion();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">Catalogo Organización</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center">{item.idorganizacion}</td>
                    <td className="py-2 text-start">{item.nombre}</td>
                    <td className="py-2 text-start">{item.domicilio}</td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
            onClick={selectOrganizacion}
            disabled={activo}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
            onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default CatalogoOrganizacionPrincipal;
